import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTwitterIconSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="twitter-icon-small_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 35 35"
    {...props}
  >
    <defs>
      <style>{'.twitter-icon-small_svg__cls-1{isolation:isolate}'}</style>
    </defs>
    <g id="twitter-icon-small_svg___" className="twitter-icon-small_svg__cls-1">
      <path
        d="M736.81 666.818v27.5a3.75 3.75 0 0 1-3.75 3.75h-27.5a3.75 3.75 0 0 1-3.75-3.75v-27.5a3.75 3.75 0 0 1 3.75-3.75h27.5a3.75 3.75 0 0 1 3.75 3.75m-5 6a10.2 10.2 0 0 1-2.953.797 5.1 5.1 0 0 0 2.25-2.82 10 10 0 0 1-3.25 1.235 5.135 5.135 0 0 0-8.742 4.68 14.55 14.55 0 0 1-10.562-5.36 5.06 5.06 0 0 0-.696 2.586v.009a5.71 5.71 0 0 0 2.282 4.257 5.1 5.1 0 0 1-2.313-.649v.063a5.124 5.124 0 0 0 4.102 5.031 5.5 5.5 0 0 1-2.313.094 5.13 5.13 0 0 0 4.79 3.554 10.27 10.27 0 0 1-6.36 2.188 11 11 0 0 1-1.234-.063 14.588 14.588 0 0 0 22.445-12.28c0-.22 0-.446-.016-.665a10.8 10.8 0 0 0 2.57-2.657"
        className="twitter-icon-small_svg__cls-1"
        style={{
          fill: '#3cf',
        }}
        transform="translate(-701.81 -663.068)"
      />
    </g>
  </svg>
);
export default SvgTwitterIconSmall;
